import {createAsyncThunk} from "@reduxjs/toolkit";
import PurchaseService from "../../services/purchase";
import ReservationsService from "../../services/reservations";

export const getPurchaseDetails = createAsyncThunk(
  "get/PurchaseDetails",
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const totalPoints = await ReservationsService.getUserTotalPoints();
      const response = await PurchaseService.getPurchaseHistory();
      return {
        presentAvailablePointsAmount: totalPoints,
        purchaseHistory: response.data?.data.map((purchaseHistoryItem: any) => {
          return {
            date: purchaseHistoryItem.created_at,
            points: purchaseHistoryItem.points,
            amount:purchaseHistoryItem.amount,
            type: purchaseHistoryItem.type,
            totalAmount: purchaseHistoryItem.amount
          }
        })
      };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getPointsPlans = createAsyncThunk(
 "get/PointsPlans",
 async (_, {rejectWithValue}) => {
   try {
     const response = await PurchaseService.getPointsPlans();
     return response.data.data.data;
   } catch (error: any) {
     return rejectWithValue(error);
   }
 }
);